import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './BlockedReasonModal.css';

/**
 * BlockedReasonModal Component
 * 
 * Modal for entering a reason when marking a task as blocked.
 * Uses the same styling as CreateSprintModal.
 * Portaled to document.body so it stacks above Mission Full View
 * (which itself portals outside .sprint-detail's isolation context).
 */
const BlockedReasonModal = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  taskName = '',
}) => {
  const [reason, setReason] = useState('');
  const inputRef = useRef(null);

  // Focus input when modal opens
  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [isOpen]);

  // Reset on close
  useEffect(() => {
    if (!isOpen) {
      setReason('');
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm?.(reason.trim());
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="modal-overlay blocked-modal-overlay" onClick={handleClose}>
      <div className="modal blocked-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal__header">
          <h2 className="modal__title">Mark as Blocked</h2>
          <button className="modal__close-btn" onClick={handleClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal__body">
            <div className="blocked-modal__task-info">
              <span className="blocked-modal__task-label">Task:</span>
              <span className="blocked-modal__task-name">{taskName}</span>
            </div>

            <div className="modal__field">
              <label className="modal__label">
                Why is this blocked?
              </label>
              <textarea
                ref={inputRef}
                className="modal__input blocked-modal__textarea"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="e.g., Waiting for client approval, dependency on external team..."
                rows={3}
              />
              <p className="modal__field-hint">
                Provide context so others know what's holding this up.
              </p>
            </div>
          </div>

          <div className="modal__footer">
            <button 
              type="button" 
              className="modal__btn modal__btn--secondary"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="modal__btn blocked-modal__btn--blocked"
            >
              Mark as Blocked
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default BlockedReasonModal;

